import React from 'react'

import { NavLink, generatePath } from 'react-router-dom'

import { ListCircleOutline, AddOutline, AppsOutline, ListOutline, TransgenderOutline } from 'react-ionicons'
import { Navbar, Nav } from 'rsuite'

import { usePartner } from '@@partner:helpers/hooks/auth'

import { ROUTE_CATALOG_CATEGORIES, ROUTE_CATALOG_CATEGORY_ADD, ROUTE_CATALOG_CATEGORY_ORDER, ROUTE_CATALOG_CATEGORY_TREE } from '@@partner:config/routes'


export default function CategorySubMenu () {
  const { brandSlug } = usePartner()

  return (
    <Navbar appearance='subtle'>
      <Nav>
        <Nav.Item
          icon={<ListOutline />}
          as={NavLink}
          to={generatePath(ROUTE_CATALOG_CATEGORIES, {
            brandSlug
          })}
        >
            Список категорий
        </Nav.Item>
        <Nav.Item
          icon={<AppsOutline />}
          as={NavLink}
          to={generatePath(ROUTE_CATALOG_CATEGORY_ORDER, {
            brandSlug
          })}
        >
            Порядок и обложки
        </Nav.Item>
        <Nav.Item
          icon={<ListCircleOutline />}
          as={NavLink}
          to={generatePath(ROUTE_CATALOG_CATEGORY_TREE, {
            brandSlug
          })}
        >
            Дерево категорий
        </Nav.Item>
        <Nav.Item
          icon={<AddOutline />}
          as={NavLink}
          to={generatePath(ROUTE_CATALOG_CATEGORY_ADD, {
            brandSlug
          })}
        >
            Добавить категорию
        </Nav.Item>
      </Nav>
    </Navbar>
  )
}